module.exports = {"451225100":"东门镇","451225101":"龙岸镇","451225102":"黄金镇","451225103":"小长安镇","451225105":"四把镇","451225106":"天河镇","451225107":"怀群镇","451225200":"宝坛乡","451225202":"乔善乡","451225203":"纳翁乡","451225204":"兼爱乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451225.json
// module id = 1988
// module chunks = 0